import { ProductsList as ProductsListComponent } from './ProductsList.component';
import { connector } from './ProductsList.connector';

export const ProductsList = connector(ProductsListComponent);
